<template>
  <div>
    <a-card size="small">
      <a-form>
        <g-dropdown label="Evaluaciones Disponibles"
                    :formItemConfig="fiOptions"
                    :cache="false"
                    endpoint="evaluaciones/competencias/eval_disponibles"
                    :selectedObj.sync="evaluacionSeleccionada"
        ></g-dropdown>
      </a-form>
    </a-card>
    <a-modal v-model="instruccionesEvaluacion" title="Instructivo"
             @cancel="!instruccionesEvaluacion"
             width="800px"
             :footer="null">
      <img style="width: 100%;height: 100%" :src="urlImagenInstructivo"/>
    </a-modal>
    <a-collapse accordion v-model="activeKey">
      <a-collapse-panel header="Personas" key="1" :disabled="panelPersonaDisabled">
        <a-card :bordered="false">
          <a-alert :message="evaluacionSeleccionada && evaluacionSeleccionada.evaluation_message"
                   v-if="evaluacionSeleccionada && evaluacionSeleccionada.evaluation_status == 1"
                   type="success" showIcon/>
          <a-alert :message="evaluacionSeleccionada && evaluacionSeleccionada.evaluation_message"
                   v-if="evaluacionSeleccionada && evaluacionSeleccionada.evaluation_status == 0"
                   type="warning"
                   showIcon/>
        </a-card>

        <g-datatable :columns="tablaEmpleados.tableSetup.columns"
                     :endpoint="tablaEmpleados.endpoint"
                     :tableConfig="tablaEmpleados.tableSetup.tableConfig"
                     :requestData="empleadosRequest"
                     :customSlots="tablaEmpleados.tableSetup.customSlots"
                     ref="datatable2">
          <template slot="customAction" slot-scope="{text, record}">
            <div v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'NO'">
              <a-popover title="" trigger="hover" v-if="record.autoevaluacion_completa == '1'">
                <template slot="content">
                  Seleccionar
                </template>
                <a-button type="link"
                          :icon="evaluacionSeleccionada.evaluation_status == 1? 'check' : 'search'"
                          v-on:click="seleccionarEmpleado(record)"
                          :loading="loadingBtns[record.evaluado] == record.evaluado"
                          style="color: green"></a-button>
              </a-popover>
            </div>
            <div v-else>
              <div v-if="record.verifica_puede_evaluar == 1">
                <a-popover title="" trigger="hover">
                  <template slot="content">
                    Seleccionar
                  </template>
                  <a-button type="link"
                            icon="check"
                            v-on:click="seleccionarEmpleado(record)"
                            :loading="loadingBtns[record.evaluado] == record.evaluado"
                            style="color: green"></a-button>

                </a-popover>
              </div>
              <div v-else>
                <a-popover title="Información" trigger="hover">
                  <template slot="content">
                    Aún no puedes evaluar a esta persona ya que aún no finaliza su autoevaluación
                    <br>
                    <a-progress :percent="parseInt(record.progreso_autoevaluacion)" status="active"/>
                  </template>
                  <a-button type="link"
                            icon="warning"
                            style="color: #FF9200"></a-button>
                </a-popover>
              </div>
            </div>
          </template>
          <template slot="progresoSlot" slot-scope="{text, record}">
            <a-progress v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'NO'"
                        :percent="parseInt(record.progreso)" status="active"/>
            <a-progress v-else :percent="parseInt(record.progreso_nuevo_tipo_evaluacion)" status="active"/>
          </template>
        </g-datatable>

      </a-collapse-panel>
    </a-collapse>
    <a-row>&nbsp;</a-row>
    <a-spin :spinning="loadingEvaluaciones">
      <a-card hoverable v-if="!panelResumenDisabled">
        <a-row :gutter="[16,16]">
          <a-col :span="12" :xs="24" :sm="12">
            <a-card-meta :title="empleadoSeleccionado.nombre_evaluado"
                         :description="empleadoSeleccionado.cargo_evaluado">
              <a-avatar
                slot="avatar"
                :src="profileSrc"
              />
            </a-card-meta>
          </a-col>
          <a-col :span="12" :xs="24" :sm="12"
                 v-if="$getConfigValue('VISUALIZAR_CALIFICACION', 'NO') === 'SI' && this.mostrarCalificacion">
            <span style="margin-left:75%; margin-right: 0; font-size: 20px">
              <strong>{{calificacionObtenida}}
                   <br>
                  <img v-if="calificacionObtenida > 70 && calificacionObtenida <=80"
                       style="width: 40px;margin-left:75%; margin-right: 0; font-size: 20px"
                       src="https://static.gbpocloud.com/sulicor/neutral.png"/>
                <img v-if="calificacionObtenida > 80"
                     style="width: 40px;margin-left:75%; margin-right: 0; font-size: 20px"
                     src="https://static.gbpocloud.com/sulicor/good-review.png"/>
                <img v-if="calificacionObtenida <= 70"
                     style="width: 40px;margin-left:75%; margin-right: 0; font-size: 20px"
                     src="https://static.gbpocloud.com/sulicor/bad-review.png"/>
              </strong>

            </span>
          </a-col>
        </a-row>
        <template class="ant-card-actions" slot="actions">
          <a-progress v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'NO'" style="width: 80%"
                      :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }" :percent="parseInt(empleadoSeleccionado.progreso)" status="active"/>
          <a-progress v-else style="width: 80%" :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }" :percent="parseInt(progresoNuevoFormatoEvaluacion)" status="active"/>
        </template>
      </a-card>
      <a-row>&nbsp;</a-row>
      <a-collapse accordion v-model="activeEmpKey" v-if="!panelResumenDisabled">
        <a-collapse-panel header="Resumen de Evaluación" key="1" forceRender v-if="mostrarResumenEvaluacion">
          <a-spin :spinning="charts.resumeLoading || charts.radarLoading">
            <a-row>
              <a-col :md="12" :sm="24" style="min-height: 400px">
                <canvas id="resumen" width="400" height="400"></canvas>
              </a-col>
              <a-col v-if="empleadoSeleccionado && empleadoSeleccionado.rol!=='FEEDBACK'" :md="12" :sm="24"
                     style="min-height: 400px">
                <canvas id="radar" width="400" height="400"></canvas>
              </a-col>
            </a-row>
          </a-spin>
        </a-collapse-panel>
        <a-collapse-panel v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'NO'" header="Competencias"
                          key="2">
          <a-row v-if="$getConfigValue('MENSAJE_EVALUACION')">
            <a-alert type="success" showIcon>
            <span slot="message" v-html="$getConfigValue('MENSAJE_EVALUACION')">
            </span>
            </a-alert>
            &nbsp;
          </a-row>
          <a-spin :spinning="competenciasLoading">
            <a-tabs type="card">
              <a-tab-pane v-for="(competencia, key) in competencias"
                          :tab="competencia[0] && competencia[0].nombre_competencia"
                          :key="key">
                <a-list :dataSource="competencia">
                  <a-list-item slot="renderItem" slot-scope="item, index">
                    <a-list-item-meta>
                      <a-avatar
                        slot="avatar"
                        :src="pictureLogo(item)"
                      />
                      <div v-html="item.comportamiento_desc" slot="description"></div>
                    </a-list-item-meta>
                    <div>
                      <template v-if="permiteModificarPreguntas">
                        <a-select :class="{error:item.has_error}" style="min-width: 120px"
                                  v-model="item.calificacion"
                                  @change="guardarComportamiento(item)"
                                  :loading="loadingDropdowns[item.id_qualification] == item.id_qualification"
                                  :disabled="loadingDropdowns[item.id_qualification] == item.id_qualification">
                          <a-select-option v-for="opcion in item.opciones" :value="opcion.value">
                            {{opcion.text}}
                          </a-select-option>
                        </a-select>
                        <a-icon type="check-circle" style="color: green" v-if="item.calificacion"/>
                        <a-icon type="exclamation-circle" style="color: red" v-else/>
                      </template>
                      <template v-else>
                        <a-alert :message="item.quality || item.calificacion" type="success"/>
                      </template>
                    </div>
                  </a-list-item>
                </a-list>
              </a-tab-pane>
            </a-tabs>
          </a-spin>
        </a-collapse-panel>
        <a-collapse-panel v-if="grupo[0].sub_grupo.length > 0" v-for="(grupo, index, key) in grupos"
                          :key="(key+6).toString()"
                          :expand-icon-position="'left'">
          <div v-show="$getConfigValue('MENSAJE_EVALUACION_'+index.toUpperCase())">
            <a-alert type="success" showIcon>
            <span slot="message" v-html="$getConfigValue('MENSAJE_EVALUACION_'+index.toUpperCase())">
            </span>
            </a-alert>
          </div>
          <br>
          <div slot="header" v-html="grupo[0].name">
            <a-icon v-if="! $isEmpty(grupo[0].icon)" :type="grupo[0].icon"/>
            {{index}}
          </div>
          <a-spin :spinning="competenciasLoading">
            <div v-for="accionesGrupo in grupo">
              <a-tabs :tabBarStyle="{color: color_config}"
                      v-if="accionesGrupo.tipo_presentacion === 'TABS'" type="card">
                <a-tab-pane v-for="(subGrupo, index) in accionesGrupo.sub_grupo" :key="(index+1).toString()">
                 <span slot="tab">
                    <a-icon v-if="subGrupo.icon" :type="subGrupo.icon"/>
                    {{subGrupo.name}}
                  </span>
                  <a-list item-layout="horizontal" :data-source="subGrupo.habilidades">
                    <a-list-item v-if="item.calificacion_empleado" slot="renderItem" slot-scope="item, index">
                      <a-list-item-meta>
                        <div style="color: black" v-html="item.name" slot="description"></div>
                        <a-avatar
                          v-if="!$isEmpty(item.icon)"
                          slot="avatar"
                          :src="item.icono_renderizado"
                        />
                      </a-list-item-meta>
                      <div v-if="permiteModificarPreguntas">
                        <div v-if="item.tipo_habilidad === 'NUMBER'">
                          <a-spin :spinning="loadingDropdownsTabs[item.id] == item.id">
                            <a-input-number style="min-width: 160px"
                                            v-model="item.calificacion_empleado.qualification"
                                            @blur="onChangeCalificacionObjetivo(item, 'TABS')"
                                            :min="parseInt(item.min)"
                                            :disabled="parseInt(progresoNuevoFormatoEvaluacion) === 100 && $getConfigValue('EVALUACIONES_BLOQUEAR_COMPLETA', 'SI') === 'SI'"
                                            :max="parseInt(item.max)"/>
                          </a-spin>
                        </div>
                        <div v-if="item.tipo_habilidad === 'LOV'">
                          <a-spin :spinning="loadingDropdownsTabs[item.id] == item.id">
                            <a-select @change="onChangeCalificacionObjetivo(item, 'TABS')"
                                      v-model="item.calificacion_empleado.qualification" style="min-width: 160px">
                              <a-select-option v-for="opcion in item.parametros_lov" :value="opcion.value"
                                               :disabled="parseInt(progresoNuevoFormatoEvaluacion) === 100 && $getConfigValue('EVALUACIONES_BLOQUEAR_COMPLETA', 'SI') === 'SI'">
                                {{opcion.label}}
                              </a-select-option>
                            </a-select>
                          </a-spin>
                          <a-icon type="check-circle" style="color: green" v-if="item.calificacion"/>
                        </div>
                        <div v-if="item.tipo_habilidad === 'LOV SQL'">
                          <a-spin :spinning="loadingDropdownsTabs[item.id] == item.id">
                            <form-model-dropdown style="min-width: 160px"
                                                 :disabled="parseInt(progresoNuevoFormatoEvaluacion) === 100 && $getConfigValue('EVALUACIONES_BLOQUEAR_COMPLETA', 'SI') === 'SI'"
                                                 @change="onChangeCalificacionObjetivo(item, 'TABS')"
                                                 endpoint="evaluacion/sql_lov_param_values"
                                                 :cache="false"
                                                 v-model="item.calificacion_empleado.qualification"
                                                 :params="{sql_query: item.sql_query}">
                            </form-model-dropdown>
                          </a-spin>
                        </div>
                      </div>
                      <div v-if="!permiteModificarPreguntas">
                        <a-alert :message="item.calificacion_empleado.qualification" type="success"/>
                      </div>
                    </a-list-item>
                  </a-list>
                </a-tab-pane>
              </a-tabs>
              <a-card size="small" style="margin-bottom: 10px" v-else
                      v-for="(subGrupo, index) in accionesGrupo.sub_grupo">
                <div slot="title">
                  <a-icon v-if="! $isEmpty(subGrupo.icon)" :type="subGrupo.icon"/>
                  {{subGrupo.name}}
                </div>
                <a-list item-layout="horizontal" :data-source="subGrupo.habilidades">
                  <a-list-item v-if="item.calificacion_empleado" slot="renderItem" slot-scope="item, index">
                    <a-list-item-meta>
                      <div style="color: black" v-html="item.name" slot="description">
                      </div>
                      <a-avatar
                        v-if="!$isEmpty(item.icon)"
                        slot="avatar"
                        :src="item.icono_renderizado"
                      />
                    </a-list-item-meta>
                    <div v-if="permiteModificarPreguntas">
                      <div v-if="item.tipo_habilidad === 'NUMBER'">
                        <a-spin :spinning="loadingDropdownsLine[item.id] == item.id">
                          <a-input-number style="min-width: 160px"
                                          :disabled="parseInt(progresoNuevoFormatoEvaluacion) === 100 && $getConfigValue('EVALUACIONES_BLOQUEAR_COMPLETA', 'SI') === 'SI'"
                                          @blur="onChangeCalificacionObjetivo(item, 'EN LÍNEA')"
                                          v-model="item.calificacion_empleado.qualification"
                                          :min="parseInt(item.min)"
                                          :max="parseInt(item.max)"/>
                        </a-spin>
                      </div>
                      <div v-if="item.tipo_habilidad === 'LOV'">
                        <a-spin :spinning="loadingDropdownsLine[item.id] == item.id">
                          <a-select @change="onChangeCalificacionObjetivo(item, 'EN LÍNEA')"
                                    v-model="item.calificacion_empleado.qualification"
                                    :disabled="parseInt(progresoNuevoFormatoEvaluacion) === 100 && $getConfigValue('EVALUACIONES_BLOQUEAR_COMPLETA', 'SI') === 'SI'"
                                    style="min-width: 160px">
                            <a-select-option v-for="opcion in item.parametros_lov" :value="opcion.value">
                              {{opcion.label}}
                            </a-select-option>
                          </a-select>
                        </a-spin>
                        <a-icon type="check-circle" style="color: green" v-if="item.calificacion"/>
                      </div>
                      <div v-if="item.tipo_habilidad === 'LOV SQL'">
                        <a-spin :spinning="loadingDropdownsLine[item.id] == item.id">
                          <form-model-dropdown style="min-width: 160px"
                                               @change="onChangeCalificacionObjetivo(item, 'EN LÍNEA')"
                                               v-model="item.calificacion_empleado.qualification"
                                               endpoint="evaluacion/sql_lov_param_values"
                                               :disabled="parseInt(progresoNuevoFormatoEvaluacion) === 100 && $getConfigValue('EVALUACIONES_BLOQUEAR_COMPLETA', 'SI') === 'SI'"
                                               :cache="false"
                                               :params="{sql_query: item.sql_query}">
                          </form-model-dropdown>
                        </a-spin>
                      </div>
                    </div>
                    <div v-if="!permiteModificarPreguntas">
                      <a-alert :message="item.calificacion_empleado.qualification" type="success"/>
                    </div>
                  </a-list-item>
                </a-list>
              </a-card>
            </div>
          </a-spin>
        </a-collapse-panel>
        <a-collapse-panel header="Formularios Disponibles" key="4"
                          v-if="parseInt(evaluacionSeleccionada.forms_enabled) === 1">
          <formularios-evaluacion :evaluado="empleadoSeleccionado" :evaluacion="evaluacionSeleccionada"
                                  v-if="evaluacionSeleccionada && empleadoSeleccionado"></formularios-evaluacion>
        </a-collapse-panel>
        <a-collapse-panel :header="$t('Retroalimentación y Plan de Acción')" key="5"
                          v-if="this.$getConfigValue('MOSTRAR_PLAN_ACCION_AUTOEVALUACION', 'NO') === 'SI'
                          && normalizeRol(empleadoSeleccionado.rol) ==='AUTOEVALUACION'
                          || (showFeedback && normalizeRol(empleadoSeleccionado.rol) !=='AUTOEVALUACION' && esEvaluacionNoventaGrados &&
                              ((parseInt(Math.round(this.empleadoSeleccionado.progreso_nuevo_tipo_evaluacion_autoevaluacion)) === 100 &&
                                (parseInt(Math.round(this.empleadoSeleccionado.progreso_nuevo_tipo_evaluacion)) === 100 || parseInt(this.progresoNuevoFormatoEvaluacion) === 100)
                               ) && this.$getConfigValue('EVALUACIONES_ACITVAR_PLAN_ACCION', 'NO') === 'SI'))
                          || (showFeedback && rolesPermitidosRetroalimentacion.includes(empleadoSeleccionado.rol))">
          <a-row>
            <a-spin :spinning="retroalimentacion.loading">
              <a-tabs defaultActiveKey="1" type="card">
                <a-tab-pane tab="Retroalimentación" key="1">
                  <a-row v-if="$getConfigValue('MENSAJE_RETROALIMENTACION')">
                    <a-alert type="success" showIcon>
                    <span slot="message" v-html="$getConfigValue('MENSAJE_RETROALIMENTACION')">
                    </span>
                    </a-alert>
                    &nbsp;
                  </a-row>
                  <a-form-model>
                    <a-form-model-item label="Ingrese retroalimentación" :rules="[{ required: campoRetroalimentacionRequerido, message: 'Este campo es requerido' }]">
                      <a-textarea autoSize v-model="retroalimentacion.value"
                                  :readOnly="!retroAlimentacionActivada  || normalizeRol(empleadoSeleccionado.rol) ==='AUTOEVALUACION'"
                                  />
                    </a-form-model-item>
                    <a-button style="float: right;" type="primary"
                              @click="guardarRetroalimentacion"
                              v-if="retroAlimentacionActivada && normalizeRol(empleadoSeleccionado.rol) !=='AUTOEVALUACION'">
                      Guardar Retroalimentación
                    </a-button>
                  </a-form-model>
                </a-tab-pane>
              </a-tabs>
            </a-spin>
          </a-row>
          <a-row>&nbsp;</a-row>
          <a-row v-if="$getConfigValue('OCULTAR_PLAN_DE_ACCION_EN_EVALUACIONES', 'NO') !== 'SI'">
            <a-tabs defaultActiveKey="1" type="card">
              <a-tab-pane tab="Plan de Acción" key="1">
                <a-row
                  v-if="$getConfigValue('MENSAJE_PLAN_ACCION') && ($getConfigValue('EVALUACIONES_CLIENTE_MASIVO', 'NO') === 'NO')">
                  <a-alert type="success" showIcon>
                    <span slot="message" v-html="$getConfigValue('MENSAJE_PLAN_ACCION')">
                    </span>
                  </a-alert>
                  &nbsp;
                </a-row>
                <a-row v-if="$getConfigValue('MENSAJE_PLAN_ACCION') &&
                             ($getConfigValue('EVALUACIONES_CLIENTE_MASIVO') === 'SI') &&
                             (
                               masivoCalificacionEva <= parseFloat(this.$getConfigValue('EVALUACIONES_ACTIVAR_PLAN_ACCION_CALIFICACION_MIN', 0)) //<= 65
                             )">
                  <a-alert type="error" message="Aviso" showIcon>
                    <span slot="description" v-html="$getConfigValue('MENSAJE_PLAN_ACCION_CALIFICACION_MIN')">
                    </span>
                  </a-alert>
                  &nbsp;
                </a-row>
                <a-row v-if="$getConfigValue('MENSAJE_PLAN_ACCION') &&
                             ($getConfigValue('EVALUACIONES_CLIENTE_MASIVO') === 'SI') &&
                             (
                               masivoCalificacionEva >= parseFloat(this.$getConfigValue('EVALUACIONES_ACTIVAR_PLAN_ACCION_CALIF_INTER1', 0)) //>= 66
                               &&
                               masivoCalificacionEva <= parseFloat(this.$getConfigValue('EVALUACIONES_ACTIVAR_PLAN_ACCION_CALIF_INTER2', 0)) //<= 80
                             )">
                  <a-alert type="error" message="Aviso" showIcon>
                    <span slot="description" v-html="$getConfigValue('MENSAJE_PLAN_ACCION_CALIFICACION_INTER')">
                    </span>
                  </a-alert>
                  &nbsp;
                </a-row>
                <g-master name="plan_accion"
                          endpoint="feedback_ations"
                          :tableSetup="planDeAccion.tableSetup"
                          :parentData="planDeAccionParentData"
                          @action="masterAction"
                          :actions="planDeAccion.actions"
                          :key="keyPlan"
                          ref="paMaster">
                  <template slot="masterModal" slot-scope="{record}">
                    <a-row :gutter="[16,16]">
                      <a-col>
                        <g-dropdown
                          v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO')==='NO'"
                          endpoint="feedback_ations/competency"
                          :params="competencyDropdownRequest"
                          :decorator="['id_competency', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :label="$t('Competencia')"
                          :formItemConfig="planDeAccion.fiOptions"/>
                        <a-form-item v-if="!isClientMasivo && $getConfigValue('NUEVO_METODO_EVALUACIONES', 'SI')==='SI'"
                                     :label="$t('PERSONALIZACION_EVA_COMPETENCIA')"
                                     v-bind="planDeAccion.fiOptions">
                          <a-select
                            @change="competenciaSeleccionada"
                            v-decorator="['att3', { rules: [
                            { required: true, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                            <a-select-option v-for="(comp, index) in getCompetencias"
                                             :key="comp.name">
                              {{ comp.name }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col v-if="mostrarComportamiento">
                        <g-dropdown v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO')==='NO'"
                                    endpoint="feedback_ations/behavior"
                                    :params="behaviorDropdownRequest"
                                    :decorator="['id_behavior', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                    :label="$t('Comportamiento')"
                                    :formItemConfig="planDeAccion.fiOptions"/>
                        <a-form-item v-else :label="$t('PERSONALIZACION_EVA_COMPORTAMIENTO')"
                                     v-bind="planDeAccion.fiOptions">
                          <a-select
                            v-decorator="['att4', { rules: [
                            { required: true, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                            <a-select-option v-for="(habilidad, index) in habilidades"
                                             :key="habilidad.name">
                              {{ habilidad.name }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col>
                        <g-dropdown
                          v-if="isClientMasivo"
                          endpoint="hierarchy_lookup"
                          :params="categoryParamsRole"
                          :decorator="['id_h_category', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :label="$t('Categoría')"
                          :formItemConfig="planDeAccion.fiOptions"/>
                        <g-dropdown
                          v-if="normalizeRol(empleadoSeleccionado.rol) !=='AUTOEVALUACION' && !isClientMasivo && mostrarCategoria"
                          endpoint="hierarchy_lookup"
                          :params="categoryDropdownRequest"
                          :decorator="['id_h_category']"
                          :label="$t('Categoría')"
                          :formItemConfig="planDeAccion.fiOptions"/>
                        <!-- <g-dropdown
                           v-else
                           endpoint="hierarchy_lookup"
                           :params="categoryDropdownRequest"
                           :decorator="['id_h_category']"
                           :label="$t('Categoría')"
                           :formItemConfig="planDeAccion.fiOptions"/> -->
                      </a-col>
                      <a-col>
                        <g-dropdown
                          v-if="mostrarSubcategoria"
                          endpoint="hierarchy_lookup"
                          :params="subCategoryDropdownRequest"
                          :decorator="['id_h_subcategory',
                        { rules: [{ required: false, message: 'Valor requerido' }]}]"
                          :label="$t('Subcategoria')"
                          :cache="false"
                          :selectConfig="{mode: !isClientMasivo ? 'multiple': 'single'}"
                          :formItemConfig="planDeAccion.fiOptions"/>

                        <a-form-item v-if="$getConfigValue('MOSTRAR_PLAN_ACCION_AUTOEVALUACION', 'NO') === 'NO'"
                                     :label="$t('PERSONALIZACION_EVA_PROYECCION_EN_LA_EMPRESA')"
                                     v-bind="planDeAccion.fiOptions">
                          <a-textarea autoSize
                                      v-decorator="['att1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                        </a-form-item>

                      </a-col>
                      <a-col v-if="mostrarAcciones">
                        <a-form-item :label="$t('PERSONALIZACION_EVA_ACCIONES_A_DESARROLLAR')"
                                     v-bind="planDeAccion.fiOptions">
                          <a-textarea autoSize
                                      v-decorator="['actions', { rules: [{ required: validaRequerido, message: 'Valor requerido' }] }]"/>
                        </a-form-item>
                      </a-col>
                      <a-col>
                        <a-form-item
                          v-if="$getConfigValue('MOSTRAR_PLAN_ACCION_AUTOEVALUACION', 'NO') === 'NO' && mostrarResponsable"
                          :label="$t('PERSONALIZACION_EVA_RESPONSABLE')" v-bind="planDeAccion.fiOptions">
                          <a-input
                            v-decorator="['companion', { rules: [{ required: validaRequerido, message: 'Valor requerido' }] }]"/>
                        </a-form-item>
                      </a-col>
                      <a-col>
                        <a-form-item v-if="evaluaciones_fecha_date_picker"
                                     :label="$t('PERSONALIZACION_EVA_FECHA_LIMITE')"
                                     v-bind="planDeAccion.fiOptions">
                          <a-date-picker style="width: 100%"
                                         valueFormat="Y-MM-DD"
                                         v-decorator="['dates', { rules: [{ required: validaRequerido, message: 'Valor requerido' }] }]"></a-date-picker>
                        </a-form-item>
                        <a-form-item v-else label="Fecha" v-bind="planDeAccion.fiOptions">
                          <a-input
                            v-decorator="['dates', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                        </a-form-item>
                      </a-col>
                      <a-col v-if="mostrarFechaSeguimiento">
                        <a-form-item :label="$t('PERSONALIZACION_EVA_FECHA_SEG')" v-bind="planDeAccion.fiOptions">
                          <a-date-picker style="width: 100%"
                                         valueFormat="Y-MM-DD"
                                         v-decorator="['att2', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                        </a-form-item>
                      </a-col>
                      <div v-show="isActiveObsStatus">
                        <a-col>
                          <a-form-item v-if="mostrarComentariosFinales
                          && normalizeRol(empleadoSeleccionado.rol) !=='AUTOEVALUACION'"
                                       :label="$t('Comentarios finales')"
                                       v-bind="planDeAccion.fiOptions">
                            <a-textarea autoSize
                                        v-decorator="['att2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                          </a-form-item>
                        </a-col>
                        <a-col>
                          <a-form-item v-if="mostrarStatus"
                                       :label="$t('Finalizado')"
                                       :has-feedback="false"
                                       v-bind="planDeAccion.fiOptions">
                            <a-checkbox
                              v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                            </a-checkbox>
                          </a-form-item>
                        </a-col>
                      </div>
                      <a-col>
                        <a-alert v-if='getMessageEvaluation' :message="getMessageEvaluation" type="warning" show-icon/>
                      </a-col>
                    </a-row>
                  </template>
                  <div slot="comportamientoRenderer" slot-scope="{text}" v-html="text"></div>
                </g-master>
              </a-tab-pane>
            </a-tabs>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel :header="$t('Observaciones y/o Comentarios')" key="8"
                          v-if="this.$getConfigValue('MOSTRAR_ITEM_OBSERVACION_EVALUACIONES', 'NO') === 'SI'">
          <a-row>
            <a-spin :spinning="obsEvaluacion.loading">
              <a-tabs defaultActiveKey="1" type="card">
                <a-tab-pane :tab="$t('Ingrese observaciones y/o comentarios')" key="1">
                  <a-row v-if="$getConfigValue('MENSAJE_ALERTA_OBS_EVALUACION')">
                    <a-alert type="info" showIcon>
                    <span slot="message" v-html="$getConfigValue('MENSAJE_ALERTA_OBS_EVALUACION')">
                    </span>
                    </a-alert>
                    &nbsp;
                  </a-row>
                  <a-form>
                    <a-form-item label="">
                      <a-textarea autoSize v-model="obsEvaluacion.value"/>
                    </a-form-item>
                    <a-button style="float: right;" type="primary"
                              @click="guardarObsEvaluacion">
                      Guardar Observación
                    </a-button>
                  </a-form>
                </a-tab-pane>
              </a-tabs>
            </a-spin>
          </a-row>
        </a-collapse-panel>
      </a-collapse>
    </a-spin>
    <a-modal v-model="visibleFinalizaEvaluacion"
             title="Información de evaluación"
             :cancel-button-props="{style: {display: 'none'} }"
             @ok="visibleFinalizaEvaluacion = false">
      <a-result
        status="success"
        title="Ha finalizado esta evaluación con éxito ! 🤗"
        sub-title=""
      >
      </a-result>
    </a-modal>
    <br><br><br><br><br><br>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import UserUtil from 'CustomModules/GlobalBPOCore/Util/UserUtil'
  import Chart from 'chart.js'

  export default {
    data () {
      return {
        urlImagenInstructivo: this.$getConfigValue('EVALUACIONES_URL_IMAGEN_INSTRUCTIVO', null),
        campoRetroalimentacionRequerido: this.$getConfigValue('CAMPO_RETROALIMENTACION_REQUERIDO', 'NO') === 'SI',
        rolesRetroalimentacion: [],
        mostrarCalificacion: false,
        calificacionObtenida: 0,
        instruccionesEvaluacion: false,
        visibleFinalizaEvaluacion: false,
        grupoCompetenciaSeleccionada: [],
        habilidades: [],
        loadingEvaluaciones: false,
        evaluador: null,
        evaluado: null,
        evaluacion: null,
        color_config: this.$getConfigValue('EVALUACIONES_COLOR_TAB', '#1890ff'),
        font_config: this.$getConfigValue('EVALUACIONES_FONT_SIZE_TAB', '14px'),
        rolSeleccionado: null,
        progresoNuevoFormatoEvaluacion: 0,
        loadingDropdownsTabs: {},
        loadingDropdownsLine: {},
        isClientMasivo: this.$getConfigValue('EVALUACIONES_ACITVAR_PLAN_ACCION', 'NO') === 'SI',
        evaluaciones_fecha_date_picker: this.$getConfigValue('EVALUACIONES_FECHA_DATE_PICKER', 'NO') === 'SI',
        activeKey: 0,
        activeEmpKey: 0,
        evaluacionSeleccionada: null,
        masivoCalificacionEva: 0,
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true,
          'class': 'evaluaciones'
        },
        loadingBtns: {},
        tablaEmpleados: {
          endpoint: 'evaluaciones/competencias/empleados',
          tableSetup: {
            columns: [
              {
                title: this.$getConfigValue('EVALUACIONES_NUEVO_NOMBRE_ACCIONES', 'Acciones'),
                key: 'acciones',
                width: 140,
                scopedSlots: {customRender: 'customAction'}
              },
              {
                title: 'Progreso',
                key: 'progreso',
                sorter: true,
                width: 130,
                scopedSlots: {customRender: 'progresoSlot'}
              },
              {title: 'Cedula', dataIndex: 'evaluado', sorter: true, width: 150},
              {title: 'Nombre Evaluado', dataIndex: 'nombre_evaluado', sorter: true, width: 250},
              {title: 'Rol', dataIndex: 'rol', sorter: true, width: 150},
              {title: 'Cargo Evaluado', dataIndex: 'cargo_evaluado', sorter: true}
            ],
            tableConfig: {
              scroll: {x: 950, y: 250},
              rowKey: 'evaluado'
            },
            customSlots: ['customAction', 'progresoSlot']
          }
        },
        empleadoSeleccionado: {},
        competencias: [],
        competenciasLoading: false,
        defaultPicture: require('./../../assets/anon_profile.png'),
        profileSrc: require('./../../assets/anon_profile.png'),
        defaultComportaminentoPicture: require('./../../assets/logoRH2_solo.png'),
        selectFiConfig: {
          style: 'min-width: 50px;'
        },
        loadingDropdowns: {},
        charts: {
          resumeLoading: false,
          radarLoading: false,
          resumenData: {},
          radarData: {}
        },
        retroalimentacion: {
          loading: false,
          value: '',
          id: -1
        },
        obsEvaluacion: {
          loading: false,
          value: '',
          id: -1
        },
        retroAlimentacionActivada: true,
        planDeAccion: {
          actions: [],
          competencySelected: null,
          categorySelected: null,
          tableSetup: {
            tableConfig: {
              rowKey: 'id_feedback_actions'
            },
            customSlots: ['comportamientoRenderer'],
            columns: [
              {title: 'Competencia', dataIndex: 'competency', sorter: true, width: 200},
              {
                title: 'Comportamiento',
                dataIndex: 'behavior',
                sorter: true,
                width: 500,
                scopedSlots: {customRender: 'comportamientoRenderer'}
              },
              {title: this.$t('Categoría'), dataIndex: 'des_category', sorter: true, width: 500},
              {title: this.$t('Subcategoria'), dataIndex: 'des_sub_category', sorter: true, width: 500},
              {
                title: this.$t('PERSONALIZACION_EVA_ACCIONES_A_DESARROLLAR'),
                dataIndex: 'actions',
                sorter: true,
                width: 500
              },
              {title: 'Responsable', dataIndex: 'companion', sorter: true, width: 200},
              {title: this.$t('PERSONALIZACION_EVA_FECHA_LIMITE'), dataIndex: 'dates', sorter: true, width: 200}
            ]
          },
          fiOptions: {
            'label-col': {span: 8},
            'wrapper-col': {span: 16},
            'has-feedback': true
          }
        },
        grupos: [],
        isActiveObsStatus: true,
        keyPlan: 0
      }
    },
    mounted () {
      document.documentElement.style.setProperty('--color', this.color_config)
      document.documentElement.style.setProperty('--font-size-list', this.font_config)
      this.httpClient = new HttpUtil()
      this.retroAlimentacionActivada = this.$getConfigValue('EVALUACION_RETROALIMENTACION_ACTIVADA', 'SI') === 'SI'
      if (this.isClientMasivo) {
        this.tablaEmpleados.tableSetup.columns.splice(2, 1)
        this.planDeAccion.tableSetup.columns.shift()
        this.planDeAccion.tableSetup.columns.shift()
        this.planDeAccion.tableSetup.columns.splice(2, 1)
        this.planDeAccion.tableSetup.columns.push({
          title: 'Comentarios',
          dataIndex: 'att2',
          sorter: true,
          width: 200
        })
        this.planDeAccion.tableSetup.columns.push({
          title: 'Finalizado',
          dataIndex: 'status_desc',
          sorter: true,
          width: 200
        })
      }
      if (!this.isClientMasivo && this.$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'SI') {
        this.planDeAccion.tableSetup.columns.shift()
        this.planDeAccion.tableSetup.columns.unshift({
          title: 'Competencia',
          dataIndex: 'att3',
          sorter: true,
          width: 200
        })
        // elimina subcategoria
        let indexSubCategory = 3
        let objSubCategory = this.planDeAccion.tableSetup.columns[indexSubCategory]
        this.planDeAccion.tableSetup.columns.splice(indexSubCategory, 1)
        // {title: 'Sub Categoría', dataIndex: 'des_sub_category', sorter: true, width: 500},
        objSubCategory['title'] = this.$t('PERSONALIZACION_EVA_PROYECCION_EN_LA_EMPRESA')
        objSubCategory['dataIndex'] = 'att1'
        this.planDeAccion.tableSetup.columns.splice(indexSubCategory, 0, objSubCategory)
        let indexBehavior = 1
        let objBehavior = this.planDeAccion.tableSetup.columns[indexBehavior]
        this.planDeAccion.tableSetup.columns.splice(indexBehavior, 1)
        objBehavior['title'] = this.$t('Comportamiento')
        objBehavior['dataIndex'] = 'att4'
        this.planDeAccion.tableSetup.columns.splice(indexBehavior, 0, objBehavior)
      }
      if (!this.isClientMasivo && this.$getConfigValue('CLIENTE_SEVICOL', 'NO') === 'SI' && this.$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'SI') {
        this.planDeAccion.tableSetup.columns.push({
          title: this.$t('PERSONALIZACION_EVA_FECHA_SEG'),
          dataIndex: 'att2',
          sorter: true
        })
      }
    },
    methods: {
      progresoNuevaEvaluacion () {
        this.httpClient.getInstance().get('progreso_nueva_evaluacion', {
          params: {
            evaluador: this.evaluador,
            evaluado: this.evaluado,
            evaluacion: this.evaluacionSeleccionada.id_evaluation
          }
        })
          .then(response => {
            this.progresoNuevoFormatoEvaluacion = response.data.progress
            if (parseFloat(this.progresoNuevoFormatoEvaluacion) > 0) {
              this.mostrarCalificacion = true
            }
            if (parseInt(this.progresoNuevoFormatoEvaluacion) === 100) {
              this.visibleFinalizaEvaluacion = true
              this.calcularCalificacionGlobal()
              if (this.rolSeleccionado !== 'AUTOEVALUACION') {
                this.validaActivaPalnAccion()
              }
            }
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar el progreso')
          })
      },
      calificacionNuevaEvaluacion () {
        if (this.rolSeleccionado === 'AUTOEVALUACION' ||
          this.rolSeleccionado === 'JEFE' ||
          this.rolSeleccionado === 'JEFE DIRECTO'
        ) {
          this.mostrarCalificacion = true
          this.httpClient.getInstance().get('calificacion_nueva_evaluacion', {
            params: {
              evaluado: this.empleadoSeleccionado.cod_evaluado,
              evaluacion: this.evaluacionSeleccionada.id_evaluation,
              rol: this.rolSeleccionado
            }
          })
            .then(response => {
              this.calificacionObtenida = parseFloat(response.data.calificacion)
            })
            .catch(() => {
              this.mostrarCalificacion = false
            })
        } else {
          this.mostrarCalificacion = false
        }
      },
      getDescription (item) {
        if (this.$isEmpty(item.attribute_1)) {
          return item.description
        } else {
          return item.description + ' (' + item.attribute_1 + ' %)'
        }
      },
      onChangeCalificacionObjetivo (item = null, tipo = null) {
        if (!this.$isEmpty(item) && tipo === 'TABS') {
          this.loadingDropdownsTabs[item.id] = item.id
        }
        if (!this.$isEmpty(item) && tipo === 'EN LÍNEA') {
          this.loadingDropdownsLine[item.id] = item.id
        }
        this.httpClient.getInstance().post('guardar_calificacion_habilidades', {
          grupos: this.grupos,
          evaluation: this.evaluacionSeleccionada.id_evaluation
        })
          .then(response => {
            Mensajes.success('Correcto', 'Se guardó correctamente la calificación')
            this.progresoNuevaEvaluacion()
            this.calificacionNuevaEvaluacion()
            this.$refs.datatable2.loadData()
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar las calificaciones')
          })
          .then(() => {
            if (!this.$isEmpty(item) && tipo === 'TABS') {
              delete this.loadingDropdownsTabs[item.id]
            }
            if (!this.$isEmpty(item) && tipo === 'EN LÍNEA') {
              delete this.loadingDropdownsLine[item.id]
            }
            this.$forceUpdate()
          })
      },
      loadPicture () {
        if (this.grupos) {
          for (const grupo in this.grupos) {
            this.grupos[grupo].forEach((item) => {
              if (item.sub_grupo.length > 0) {
                item.sub_grupo.forEach(item => {
                  if (item.habilidades.length > 0) {
                    item.habilidades.forEach(item => {
                      if (!this.$isEmpty(item.icon)) {
                        this.httpClient.getInstance().get('render_image', {
                          params: {ruta: item.icon},
                          responseType: 'arraybuffer'
                        })
                          .then((response) => {
                            let blob = new Blob([response.data], {type: response.headers['content-type']})
                            item.icono_renderizado = window.URL.createObjectURL(blob)
                          })
                      }
                    })
                  }
                })
              }
            })
          }
        }
      },
      pictureLogo (item) {
        if (!this.$isEmpty(item.picture)) {
          return require('./../../assets/' + item.picture)
        } else {
          return this.defaultComportaminentoPicture
        }
      },
      seleccionarEmpleado (record) {
        this.rolSeleccionado = record.rol
        this.empleadoSeleccionado = record
        this.activeEmpKey = 6
        this.activeKey = 0
        let autoevaluacion = this.normalizeRol(record.rol) === 'AUTOEVALUACION'
        this.masivoCalificacionEva = parseFloat(this.empleadoSeleccionado.calificacion_global)
        if (!autoevaluacion) {
          this.validaActivaPalnAccion()
          if (this.isClientMasivo) {
            this.guardarRetroalimentacion()
          }
        }
        this.planDeAccion.actions = []
        this.keyPlan++
        let validation = (autoevaluacion && this.esPlanAccionAutoevaluacion) || !this.esPlanAccionAutoevaluacion
        this.planDeAccion.actions.push({
          name: 'masterCreate',
          text: 'Crear',
          permisos: [],
          fnVisible: () => validation,
          props: {icon: 'plus', type: 'button'}
        })
        this.competenciasLoading = true
        this.loadEmployPicture(this.empleadoSeleccionado.evaluado)
        this.httpClient.getInstance().get('evaluaciones/competencias/evaluacion_empleado', {
          params: {
            'id_evaluation': this.evaluacionSeleccionada.id_evaluation,
            'evaluado': this.empleadoSeleccionado.evaluado
          }
        })
          .then((response) => {
            this.competencias = response.data
            for (let comp in this.competencias) {
              if (this.competencias.hasOwnProperty(comp)) {
                this.competencias[comp].map((competencia) => {
                  competencia.opciones = []
                  let nOpt = competencia.raw_options.split(',')
                  nOpt.map((opt) => {
                    let optVect = opt.split(':')
                    competencia.opciones.push({
                      value: optVect[1], // valor
                      text: optVect[0], // descripcion
                      conversion: optVect[2]// conver
                    })
                  })
                })
              }
            }
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible cargar los datos del empleado')
          })
          .then(() => {
            this.competenciasLoading = false
          })

        this.loadingEvaluaciones = true
        this.httpClient.getInstance().get('grupo_por_evaluacion', {
          params: {
            'id_evaluation': this.evaluacionSeleccionada.id_evaluation,
            'cargo_evaluado': this.empleadoSeleccionado.cargo_evaluado,
            'id_evaluated': this.empleadoSeleccionado.evaluado
          }
        })
          .then((response) => {
            if (!this.$isEmpty(response.data)) {
              this.grupos = response.data.grupos
              this.progresoNuevoFormatoEvaluacion = response.data.progreso.progress
              this.evaluador = response.data.progreso.id_evaluator
              this.evaluado = response.data.progreso.id_evaluated
              this.evaluacion = response.data.progreso.id_evaluacion
              this.loadPicture()
            }
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible cargar las habilidades a evaluar')
          })
          .then(() => {
            this.competenciasLoading = false
            this.loadingEvaluaciones = false
          })
        this.loadGraphData()
        this.loadRetroAlimentacion()
        this.loadObservacionEvaluacion()
        this.calificacionNuevaEvaluacion()
      },
      loadEmployPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
      },
      guardarComportamiento (comportamiento) {
        this.loadingDropdowns[comportamiento.id_qualification] = comportamiento.id_qualification
        comportamiento.has_error = false

        /* busca el vlaor seleccionado */
        let opSelected = null
        comportamiento.opciones.map(opcion => {
          if (opcion.value === comportamiento.calificacion) {
            opSelected = opcion
          }
        })

        this.httpClient.getInstance().post('evaluaciones/competencias/actualizar_evaluacion', {
          id_qualification: comportamiento.id_qualification,
          calificacion: comportamiento.calificacion,
          quality: opSelected.text,
          conversion: opSelected.conversion,
          evaluado: this.empleadoSeleccionado.cod_evaluado,
          id_evaluation: this.evaluacionSeleccionada.id_evaluation
        })
          .then(response => {
            comportamiento.has_error = false
            this.empleadoSeleccionado.progreso = response.data.progreso
            this.empleadoSeleccionado.calificacion_global = response.data.calificacion_global
            this.loadGraphData()
            this.loadRetroAlimentacion()
            this.loadObservacionEvaluacion()
            this.masivoCalificacionEva = parseFloat(response.data.calificacion_global)
            this.validaActivaPalnAccion()
            if (parseInt(response.data.progreso) === 100 || parseInt(this.empleadoSeleccionado.progreso_nuevo_tipo_evaluacion) === 100) {
              this.seleccionarEmpleado(this.empleadoSeleccionado)
            }
          })
          .catch(error => {
            comportamiento.has_error = true
            let result = 'No fue posible actualizar el comportamiento'
            if (!JsUtils.isEmpty(error.response)) {
              result = JsUtils.isEmpty(error.response.data) ? 'No fue posible actualizar el comportamiento' : error.response.data.message
            }
            Mensajes.error('Error', result)
          })
          .then(() => {
            delete this.loadingDropdowns[comportamiento.id_qualification]
            this.$forceUpdate()
          })
      },
      initResumeChart (barChartData) {
        this.charts.resumenData = barChartData
        this.resumenChart = new Chart('resumen', {
          type: 'line',
          data: this.charts.resumenData,
          options: {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: 'Resumen de Calificación'
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: true
                }
              }],
              yAxes: [{
                gridLines: {
                  display: true
                },
                ticks: {
                  beginAtZero: this.$getConfigValue('EVALUACION_RESUMEN_INICIA_EN_CERO', 'NO') === 'SI'
                }
              }]
            }
          }
        })
      },
      updateResumeChart (barChartData) {
        this.charts.resumenData.datasets.splice(0, this.charts.resumenData.datasets.length)
        this.charts.resumenData.labels.splice(0, this.charts.resumenData.labels.length)
        barChartData.labels.map(label => {
          this.charts.resumenData.labels.push(label)
        })
        barChartData.datasets.map(dataset => {
          this.charts.resumenData.datasets.push(dataset)
        })
        this.resumenChart.update()
      },
      initRadarChart (barChartData) {
        this.charts.radarData = barChartData
        this.radarChart = new Chart('radar', {
          type: 'radar',
          data: this.charts.radarData,
          options: {
            maintainAspectRatio: false,
            spanGaps: false,
            title: {
              display: true,
              text: this.$t('Radar de Desarrollo')
            },
            scale: {
              pointLabels: {
                fontSize: 14
              },
              ticks: {
                beginAtZero: true
              }
            },
            tooltips: {
              enabled: true,
              callbacks: {
                title: function (tooltipItem, data) {
                  let result = []
                  tooltipItem.map(tiTm => {
                    result.push(data.labels[tiTm.index])
                  })
                  return result
                }
              }
            }
          }
        })
      },
      updateRadarChart (barChartData) {
        this.charts.radarData.datasets.splice(0, this.charts.radarData.datasets.length)
        this.charts.radarData.labels.splice(0, this.charts.radarData.labels.length)
        barChartData.labels.map(label => {
          this.charts.radarData.labels.push(label)
        })
        barChartData.datasets.map(dataset => {
          this.charts.radarData.datasets.push(dataset)
        })
        this.radarChart.update()
      },
      loadGraphData () {
        this.charts.resumeLoading = true
        this.charts.radarLoading = true
        this.httpClient.getInstance().get('evaluaciones/competencias/datos_resumen',
          {
            params: {
              evaluado: this.empleadoSeleccionado.cod_evaluado,
              id_evaluation: this.evaluacionSeleccionada.id_evaluation
            }
          })
          .then(({data}) => {
            // COVINOC
            if (this.empleadoSeleccionado.rol === 'FEEDBACK') {
              data.datasets = data.datasets.filter(item => item.label === 'FEEDBACK' || item.label === 'MODELO')
            }

            if (JsUtils.isEmpty(this.resumenChart)) {
              this.initResumeChart(data)
            } else {
              this.updateResumeChart(data)
            }
            this.charts.resumeLoading = false
          })

        this.httpClient.getInstance().get('evaluaciones/competencias/datos_resumen_radar',
          {
            params: {
              evaluado: this.empleadoSeleccionado.cod_evaluado,
              id_evaluation: this.evaluacionSeleccionada.id_evaluation
            }
          })
          .then(response => {
            if (JsUtils.isEmpty(this.radarChart)) {
              this.initRadarChart(response.data)
            } else {
              this.updateRadarChart(response.data)
            }
            this.charts.radarLoading = false
          })
      },
      loadRetroAlimentacion () {
        this.retroalimentacion.loading = true
        this.retroalimentacion.id = -1

        this.httpClient.getInstance().get('evaluaciones/competencias/retroalimentacion',
          {
            params: {
              evaluado: this.empleadoSeleccionado.cod_evaluado,
              id_evaluation: this.evaluacionSeleccionada.id_evaluation
            }
          })
          .then(response => {
            this.retroalimentacion.value = response.data.feedback
            this.retroalimentacion.loading = false
            this.retroalimentacion.id = JsUtils.isEmpty(response.data.id_feedback) ? -1 : response.data.id_feedback
          })
      },
      guardarRetroalimentacion () {
        let retroalimentacion = this.retroalimentacion.value
        if (this.isClientMasivo) {
          retroalimentacion = 'CONTINUAR CON PLAN DE ACCIÓN'
        }
        if (this.evaluacionSeleccionada.evaluation_status === 0 || this.$isEmpty(retroalimentacion)) return
        this.retroalimentacion.loading = true
        this.httpClient.getInstance().post('evaluaciones/competencias/guardar_retroalimentacion',
          {
            evaluado: this.empleadoSeleccionado.cod_evaluado,
            id_evaluation: this.evaluacionSeleccionada.id_evaluation,
            retroalimentacion: retroalimentacion
          })
          .then(response => {
            if (!this.isClientMasivo) {
              Mensajes.success('Correcto', 'Guardado correctamente.')
            }
            this.retroalimentacion.loading = false
            this.loadRetroAlimentacion()
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar el comportamiento.')
            this.retroalimentacion.loading = false
          })
      },
      masterAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.id_competency)) {
              this.planDeAccion.competencySelected = action.changedFields.id_competency.value
            }

            if (!JsUtils.isEmpty(action.changedFields.id_competency) && JsUtils.isEmpty(action.changedFields.id_behavior)) {
              this.$refs.paMaster.modal.form.setFieldsValue({id_behavior: null})
            }

            if (!JsUtils.isEmpty(action.changedFields.id_h_category)) {
              this.planDeAccion.categorySelected = action.changedFields.id_h_category.value
              this.$refs.paMaster.modal.form.setFieldsValue({id_h_subcategory: undefined})
            }
            break
          case 'masterEdit':
            this.planDeAccion.categorySelected = action.record.id_h_category
            if (!this.$isEmpty(action.record.att3)) {
              this.competenciaSeleccionada(action.record.att3)
            }
            if (this.isClientMasivo && !this.$isEmpty(action.record.dates)) {
              let date = moment(action.record.dates)
              if (date.isValid()) {
                this.isActiveObsStatus = moment().isAfter(date)
              }
            }
            break
          case 'masterCreate':
            this.isActiveObsStatus = !this.isClientMasivo
            break
        }
      },
      validaActivaPalnAccion () {
        if (!this.showFeedback) {
          return
        }

        // ACTIVAR PLAN DE ACCIÓN
        if ((parseInt(this.empleadoSeleccionado.progreso) === 100 ||
          parseInt(this.empleadoSeleccionado.progreso_nuevo_tipo_evaluacion) === 100 ||
          parseInt(this.progresoNuevoFormatoEvaluacion) === 100) &&
          (this.$getConfigValue('EVALUACIONES_ACITVAR_PLAN_ACCION', 'NO') === 'SI')) {
          this.activeEmpKey = 5
        }
      },
      competenciaSeleccionada (data) {
        if (!this.isClientMasivo) {
          let competenciaFiltrada = this.grupoCompetenciaSeleccionada.find(element => element.name === data)
          this.habilidades = competenciaFiltrada.habilidades
        }
      },
      normalizeRol (str) {
        if (!this.$isEmpty(str)) {
          return str.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        }
      },
      calcularCalificacionGlobal () {
        this.httpClient.getInstance().get('calificacion_global', {
          params: {
            evaluado: this.empleadoSeleccionado.cod_evaluado,
            evaluacion: this.evaluacionSeleccionada.id_evaluation
          }
        })
          .then(response => {
            this.masivoCalificacionEva = parseFloat(response.data)
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar la calificacion global')
          })
      },
      guardarObsEvaluacion () {
        let obs = this.obsEvaluacion.value
        if (this.evaluacionSeleccionada.evaluation_status === 0 || this.$isEmpty(obs)) return
        this.obsEvaluacion.loading = true
        this.httpClient.getInstance().post('evaluaciones/competencias/guardar_observacion',
          {
            id_evaluation: this.evaluacionSeleccionada.id_evaluation,
            id_evaluated: this.empleadoSeleccionado.cod_evaluado,
            id_evaluator: this.evaluador,
            observacion: obs
          })
          .then(response => {
            Mensajes.success('Correcto', 'Guardado correctamente.')
            this.obsEvaluacion.loading = false
            this.loadObservacionEvaluacion()
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar la observación.')
            this.obsEvaluacion.loading = false
          })
      },
      loadObservacionEvaluacion () {
        this.obsEvaluacion.loading = true
        this.obsEvaluacion.id = -1

        this.httpClient.getInstance().get('evaluaciones/competencias/observaciones',
          {
            params: {
              id_evaluation: this.evaluacionSeleccionada.id_evaluation,
              id_evaluated: this.empleadoSeleccionado.cod_evaluado,
              id_evaluator: this.evaluador
            }
          })
          .then(response => {
            this.obsEvaluacion.value = response.data.observacion
            this.obsEvaluacion.loading = false
            this.obsEvaluacion.id = JsUtils.isEmpty(response.data.observacion) ? -1 : response.data.observacion
          })
      }
    },
    computed: {
      panelPersonaDisabled () {
        this.instruccionesEvaluacion = !JsUtils.isEmpty(this.evaluacionSeleccionada) && this.$getConfigValue('MOSTRAR_INSTRUCTIVO', 'NO') === 'SI'
        return JsUtils.isEmpty(this.evaluacionSeleccionada)
      },
      categoryParamsRole () {
        let lookup = {h_lookup_type: 'SKILLS_CATEGORY', id_h_lookup_father: this.empleadoSeleccionado.nivel_evaluado}
        if (this.isClientMasivo) {
          lookup = {h_lookup_type: 'FORMACION_TECNICA'}
        }
        return lookup
      },
      panelResumenDisabled () {
        return JsUtils.isEmpty(this.empleadoSeleccionado)
      },
      empleadosRequest () {
        if (!JsUtils.isEmpty(this.evaluacionSeleccionada)) {
          return {id_evaluation: this.evaluacionSeleccionada.id_evaluation}
        }
        return {id_evaluation: -1}
      },
      planDeAccionParentData () {
        return {
          id_feedback: this.retroalimentacion.id
        }
      },
      competencyDropdownRequest () {
        return {
          id_evaluado: this.empleadoSeleccionado.cod_evaluado,
          id_evaluacion: this.evaluacionSeleccionada.id_evaluation
        }
      },
      behaviorDropdownRequest () {
        if (JsUtils.isEmpty(this.planDeAccion.competencySelected)) {
          return {
            id_evaluado: -1,
            id_evaluacion: -1,
            id_competencia: -1
          }
        } else {
          return {
            id_evaluado: this.empleadoSeleccionado.cod_evaluado,
            id_evaluacion: this.evaluacionSeleccionada.id_evaluation,
            id_competencia: this.planDeAccion.competencySelected
          }
        }
      },
      showFeedback () {
        return UserUtil.isInRol('SkillsFeedbacker')
      },
      categoryDropdownRequest () {
        return {
          h_lookup_type: 'SKILLS_CATEGORY'
        }
      },
      subCategoryDropdownRequest () {
        let lookup = {
          h_lookup_type: 'FORMACION_COMPETENCIAS',
          id_h_lookup_father: this.planDeAccion.categorySelected || -1
        }
        if (!this.isClientMasivo) {
          lookup = {
            h_lookup_type: 'SKILLS_SUBCATEGORY',
            id_h_lookup_father: this.planDeAccion.categorySelected || -1
          }
        }
        return lookup
      },
      permiteModificarPreguntas () {
        if (!this.evaluacionSeleccionada.evaluation_status) {
          return false
        }
        let progresoEmpleado = this.empleadoSeleccionado.progreso
        if (parseInt(progresoEmpleado) === 100) {
          this.visibleFinalizaEvaluacion = true
        }
        return (parseInt(progresoEmpleado) !== 100 || this.$getConfigValue('EVALUACIONES_BLOQUEAR_COMPLETA', 'NO') === 'NO')
      },
      mostrarAcciones () {
        return this.$getConfigValue('EVALUACIONES_OCULTAR_ACCIONES', 'NO') === 'NO'
      },
      mostrarCategoria () {
        return this.$getConfigValue('EVALUACIONES_OCULTAR_CATEGORIA', 'NO') === 'NO'
      },
      mostrarSubcategoria () {
        return this.$getConfigValue('EVALUACIONES_OCULTAR_SUBCATEGORIA', 'NO') === 'NO'
      },
      mostrarComportamiento () {
        return this.$getConfigValue('EVALUACIONES_OCULTAR_COMPORTAMIENTO', 'NO') === 'NO'
      },
      mostrarComentariosFinales () {
        return this.$getConfigValue('EVALUACIONES_OCULTAR_COMENTARIOS_FINALES', 'SI') === 'NO'
      },
      mostrarStatus () {
        return this.$getConfigValue('EVALUACIONES_OCULTAR_STATUS', 'SI') === 'NO'
      },
      mostrarFechaSeguimiento () {
        return this.$getConfigValue('EVALUACIONES_MOSTRAR_FECHA_SEGUIMIENTO', 'NO') === 'SI'
      },
      mostrarResponsable () {
        return this.$getConfigValue('EVALUACIONES_OCULTAR_RESPONSABLE', 'NO') === 'SI'
      },
      validaRequerido () {
        return this.$getConfigValue('EVALUACIONES_FLIMITE_ACCIONES_RESPON_REQUERIDO', 'SI') === 'SI'
      },
      getMessageEvaluation () {
        return this.$getConfigValue('EVALUACION_MESSAGE_PLAN_ACCION')
      },
      mostrarResumenEvaluacion () {
        let config = this.$getConfigValue('ROLES_PERMITIDOS_RESUMEN_EVALUACION', null)
        if (this.$isEmpty(config)) {
          return true
        } else {
          const rolesPermitidos = config.split(',')
          return rolesPermitidos.includes(this.rolSeleccionado)
        }
      },
      getCompetencias () {
        if (this.isClientMasivo && this.competencias.hasOwnProperty('Competencias')) {
          let competencias = this.competencias.Competencias.map(item => item.comportamiento_desc)
            .filter((value, index, self) => self.indexOf(value) === index)
          return competencias.map(item => { return {name: item} })
        }

        let grupos = Object.values(this.grupos)
        if (!this.$isEmpty(grupos)) {
          if (this.$getConfigValue('CLIENTE_SEVICOL', 'NO') === 'SI') {
            this.grupoCompetenciaSeleccionada = grupos[0][0]['sub_grupo'].concat(grupos[1][0]['sub_grupo'])
            return this.grupoCompetenciaSeleccionada
          } else if (this.$getConfigValue('EVA_CLIENTE_CON_DOS_HABILIDADES_Y_CONOCIMIENTOS', 'NO') === 'SI') {
            this.grupoCompetenciaSeleccionada = grupos[0][0]['sub_grupo'].concat(grupos[1][0]['sub_grupo'])
            return this.grupoCompetenciaSeleccionada
          } else {
            this.grupoCompetenciaSeleccionada = grupos[0][0]['sub_grupo']
            return this.grupoCompetenciaSeleccionada
          }
        }
      },
      esEvaluacionNoventaGrados () {
        if (this.isClientMasivo) {
          return this.empleadoSeleccionado.rol === 'JEFE'
        } else {
          return false
        }
      },
      rolesPermitidosRetroalimentacion () {
        let roles = this.$getConfigValue('ROLES_RETROALIMENTACION')
        if (roles) {
          this.rolesRetroalimentacion = roles.split(',')
        }
        return this.rolesRetroalimentacion
      },
      esPlanAccionAutoevaluacion () {
        return this.$getConfigValue('MOSTRAR_PLAN_ACCION_AUTOEVALUACION', 'NO') === 'SI'
      }
    },
    watch: {
      evaluacionSeleccionada () {
        if (!JsUtils.isEmpty(this.evaluacionSeleccionada)) {
          this.activeKey = 1
        }
        this.empleadoSeleccionado = {}
        this.resumenChart = null
        this.radarChart = null
        this.retroalimentacion = {
          loading: false,
          value: '',
          id: -1
        }
      }
    }
  }
</script>
<style>

  .error > .ant-select-selection.ant-select-selection--single {
    border-color: red;
  }

  .evaluaciones.ant-row.ant-form-item {
    margin-bottom: 0;
  }

  :root {
    --color: #1890ff;
    --font-size-list: 14px
  }

  .ant-tabs-nav .ant-tabs-tab-active {
    color: var(--color);
    font-weight: 500;
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: var(--color);
    background: #fff;
    border-color: #e8e8e8;
    border-bottom: 1px solid #fff;
  }

  .ant-tabs-nav .ant-tabs-tab:hover {
    color: var(--color);
  }

  .ant-list-item-meta-description {
    color: rgba(0, 0, 0, .45);
    font-size: var(--font-size-list);
    line-height: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Evaluaciones.vue